module.exports = __webpack_public_path__ + "static/media/18.26f1f5e2.jfif";